import { Theme } from '@material-ui/core';
import { SkeletonClassKey } from '@material-ui/lab/Skeleton';

export const muiSkeletonOverrides = (): Theme['overrides'] => ({
  MuiSkeleton: {
    root: {
      display: 'inline-block',
    },
  },
});

declare module '@material-ui/core/styles/overrides' {
  export interface ComponentNameToClassKey {
    MuiSkeleton: SkeletonClassKey;
  }
}
